import { unitMapping } from 'lib/style';
import { Color } from 'style/types';

type Props = {
  color?: Color;
  size?: keyof typeof unitMapping;
  title?: string;
};

export const RevealCard = ({ color, size = 2, title }: Props) => {
  return (
    <svg
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
    >
      {title ? <title>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1C0 0.447715 0.447715 0 1 0H11C11.5523 0 12 0.447715 12 1V15C12 15.5523 11.5523 16 11 16H1C0.447715 16 0 15.5523 0 15V1ZM2 2V14H10V2H2ZM6.0625 6C5.78636 6 5.5625 6.22386 5.5625 6.5C5.5625 6.77614 5.78636 7 6.0625 7C6.33864 7 6.5625 6.77614 6.5625 6.5C6.5625 6.22386 6.33864 6 6.0625 6ZM3.5625 6.5C3.5625 5.11929 4.68179 4 6.0625 4C7.44321 4 8.5625 5.11929 8.5625 6.5C8.5625 7.88071 7.44321 9 6.0625 9C4.68179 9 3.5625 7.88071 3.5625 6.5ZM6 11C5.38397 11 4.9375 11.4765 4.9375 12H2.9375C2.9375 10.3144 4.33786 9 6 9C7.66214 9 9.0625 10.3144 9.0625 12H7.0625C7.0625 11.4765 6.61603 11 6 11Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
};
